import HttpClient from './HttpClient';
import { OPINION_SERVICE_HOST, OPINIONS_API_PREFIX } from './RestConstants';

export interface UrlPreviewData {
  url: string;
  title?: string;
  description?: string;
  image?: string;
  siteName?: string;
}

export async function getUrlPreview(url: string): Promise<UrlPreviewData> {
  const response = await HttpClient.GET({
    BASE_URL: OPINION_SERVICE_HOST,
    END_POINT: `${OPINIONS_API_PREFIX}/url-preview?url=${encodeURIComponent(url)}`,
  });

  return response.data;
}
